/**
 * Machine-readable reason a patient booking was rejected (PRD #1343, RS-001).
 * Returned in the body of a `409 Conflict` so the frontend can react precisely
 * — `SLOT_TAKEN` removes the tapped chip and refreshes the grid without
 * dropping the patient out of the flow.
 */
export var PatientBookingConflictCode;
(function (PatientBookingConflictCode) {
    /** The chosen slot was booked by someone else between render and tap. */
    PatientBookingConflictCode["SLOT_TAKEN"] = "SLOT_TAKEN";
})(PatientBookingConflictCode || (PatientBookingConflictCode = {}));
//# sourceMappingURL=patient-booking-conflict.enum.js.map